<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            :main_icon="main_icon"
            :icons="icon_data"
            :load_url="load_url"
            :title="title">
    </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard';

    export default {
        name: 'TodaysReturnsOfReturnsStatus',
        components: {DashboardCard},
        props: {
            width: {type:Number, default: 25},
            dataDisplay: {type:String, default: null},
        },
        data() {
            return {
                main_icon:'fa-light fa-share',
                title: 'Returns of Returns Today',
                load_url: '/dashboards/TodaysReturnsOfReturns',
                icon_data: [
                    {
//                        name: 'First returns of Returns',
                        name: 'First',
                        text_color: '#F4A261',
                    },
                    {
//                        name: 'Second Returns of Returns',
                        name: 'Second',
                        text_color: '#264653',
                    },
                    {
//                        name: 'Second Returns of Returns Day 90',
                        name: 'Day 90',
                        text_color: '#53111c',
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>